import { Mobile } from 'iconsax-react';
import { lazy, Suspense, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useOnClickOutside } from 'usehooks-ts';
import LoadingLayout from '@/components/layouts/progress-layout/loading-layout';
import useVersions from '@/hooks/settings/use-versions';
import { setIsDesktop } from '@/stores/layout-status';

const QRCode = lazy(() => import('react-qr-code'));

export default function AppDownloadPrompt() {
  const { t } = useTranslation();
  const { data } = useVersions();
  const detailRef = useRef<HTMLDetailsElement>(null);
  useOnClickOutside(detailRef, () => detailRef.current?.removeAttribute('open'));

  return (
    <details
      className='hidden dropdown-bottom dropdown-end dropdown-right dropdown desktop:flex'
      ref={detailRef}>
      <summary className='flex desktop:size-14 flex-center desktop:text-neutral-0'>
        <Mobile
          variant='Bold'
          className='size-8'
        />
      </summary>
      <div className='dropdown-content flex flex-col items-center w-[19rem] rounded-xl p-6 shadow-xl gap-2 bg-neutral-0'>
        <Suspense fallback={<LoadingLayout className='aspect-square size-64' />}>
          <QRCode
            className='size-64 p-4 rounded-none'
            level='L'
            value={data?.AndroidDownLoadUrl ?? ''}
            size={256}
          />
        </Suspense>

        <p className='font-bold'>{t('nav.download-app')}</p>
        <button
          type='button'
          className='btn btn-ghost flex items-center gap-2 text-body w-[100%] text-h3'
          onClick={() => {
            setIsDesktop(false);
          }}>
          {t('general-settings.display-mode.change-to-mobile')}
        </button>
      </div>
    </details>
  );
}
